module.exports = __webpack_public_path__ + "img/21.b2752bd1.jpg";